import { render, staticRenderFns } from "./VeHrPeixunModal.vue?vue&type=template&id=582bda60"
import script from "./VeHrPeixunModal.vue?vue&type=script&lang=js"
export * from "./VeHrPeixunModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports